import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

type CardFieldProps = {
    label: string,
    value: string,
    onClick?: () => void,
    className?: string,
    style?: React.CSSProperties,
};

CardField.defaultProps = {
    onClick: () => {},
    className: '',
    style: {},
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    field: {

    },
    label: {
        color: theme.palette.text.secondary,
        fontWeight: 700,
    },
    value: {
        padding: theme.spacing(1, 0),
        fontSize: 18,
        fontWeight: 500,
    },
}));

function CardField(props: CardFieldProps): React.ReactElement {
    const {
        label,
        value,
        onClick,
        className,
        style,
    } = props;
    const classes = useStyle();

    return (
        <div className={clsx(classes.field, className)} style={style}>
            <div className={classes.label}>{label}</div>
            <div className={classes.value} onClick={onClick}>{value}</div>
        </div>
    );
}

export { CardField };
